import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
    IAppEnvironment,
} from '../model/iapp-types';

import * as CryptoJS from 'crypto-js';

@Injectable()
export class AppEnvService {
    private config: IAppEnvironment;
    // Caches the in-flight/completed load so load() is safe to call more than
    // once - the app initializer calls it to gate bootstrap, and anything else
    // that needs to be sure `config` is populated (e.g. LoginGuard, which can
    // run before the app initializer in some navigation timings) can just
    // await the same promise instead of triggering a second fetch or racing it.
    private loadPromise: Promise<void> | null = null;

    constructor(
        public http: HttpClient
    ) {
    }

    encryptionConfig(): boolean {
        return false;//this.config.storageEncryption;
    }
    version(): string {
        return this.config.version;
    }
    build(): string {
        return this.config.build;
    }
    timeoutDuration(): string {
        return this.config.timeoutDuration;
    }
    warningDuration(): string {
        return this.config.warningDuration;
    }
    EngineEndpointName(): string {
        return this.config.EngineEndpointName;
    }
    AppEndpointName(): string {
        return this.config.AppEndpointName;
    }
    load(): Promise<void> {
        if (this.loadPromise) {
            return this.loadPromise;
        }
        this.loadPromise = new Promise((res, rej) => {
            const subscription =this.http.get('/assets/environment.json').subscribe(env => {
                const e = env as any;
                if (e.encrypted !== undefined) {
                    const bytes = CryptoJS.AES.decrypt(e.encrypted, '0123456789');
                    const original = bytes.toString(CryptoJS.enc.Utf8);
                    this.config = JSON.parse(original);
                } else {
                    this.config = env;
                }
                res();
            },
            (error) => {
                console.error('Error loading environment configuration:', error);
                rej(error);
              },
            () => {
                // Clean up: unsubscribe from the observable
                subscription.unsubscribe();
              }
        );
        });
        return this.loadPromise;
    }
}
